export default "__VITE_ASSET__CnovcJbs__"